import { UPDATE_SEARCH_HOTEL } from '../actions';

export const updateSearchHotel = (search) => ({
  type: UPDATE_SEARCH_HOTEL,
  payload: {
    search,
  },
});
